module.exports = __webpack_public_path__ + "static/media/logoF.4bf68b1e.png";